<template>
    <div style="pointer-events: none;">
        <svg id="the-frame" ref="frame" class="fullscreen" fill="none">
            <!-- 
            Frame Components 
            -->
            <!-- Landing animation -->
            <grid-lines v-if="isLanding"></grid-lines>
            <!-- Animated -->
            <smash-delta-and-title
                v-if="isLanding"
                key="smash-delta-logo-landing"
                class="logo"
                id="smash-delta"
                :height="h"
            ></smash-delta-and-title>
            <!-- Header -->
            <a v-else href="https://smashdelta.com/">
                <smash-delta
                    id="smash-delta-svg"
                    class="logo"
                    :height="logoHeight"
                    fill="sd-white"
                    :animated="true"
                    :interval="5000"
                    preserveAspectRatio="xMinYMid"
                    pointer-events="visible"
                ></smash-delta>
            </a>

            <full-screen></full-screen>
            <scroll-to-explore></scroll-to-explore>

            <!-- Todo : Move these -->
            <!-- FrameAnimators -->
            <frame-animators
                v-if="hasMounted"
                :key="`frame-animators-${nextTickKey}`"
                :rootElement="$refs.frame"
            ></frame-animators>
        </svg>
        <intro-para/>
    </div>
</template>

<script>
import SmashDelta from '@/components/SmashDelta/SmashDeltaLogo'
import SmashDeltaAndTitle from '@/assets/svg/logo-and-title.svg'
import GridLines from './GridLines'
import FrameAnimators from './FrameAnimators'
import { mapState } from 'vuex'
import ScrollToExplore from './ScrollToExplore'
import FullScreen from './FullScreen'
import IntroPara from './IntroPara'

export default {
    components: {
        SmashDelta,
        GridLines,
        FrameAnimators,
        ScrollToExplore,
        FullScreen,
        SmashDeltaAndTitle,
        IntroPara
    },

    data() {
        return {
            hasMounted: false,
            nextTickKey: 0
        }
    },

    computed: {
        ...mapState(['w', 'h', 'scene']),

        isLanding() {
            return this.scene === 'landing'
        },

        logoHeight() {
            return this.w < 600 ? 50 : 80
        }
    },

    watch: {
        w() {
            this.updateKey()
        },

        h() {
            this.updateKey()
        }
    },

    methods: {
        updateKey() {
            this.$nextTick().then(() => (this.nextTickKey += 1))
        },
        clickHandler() {
            location.reload()
        }
    },

    mounted() {
        this.$nextTick().then((this.hasMounted = true))
    }
}
</script>

<style>
.logo {
    cursor: pointer;
}
</style>
